import { fetchData } from '@eliadmin/core/src/api/fetcher';

export type InstagramMedia = {
  id: string;
  media_type: string;
  media_url: string;
  caption?: string;
  like_count: number;
  comments_count: number;
  permalink: string;
};

export const fetchInstagramMedia = async ({ results }: { results: number }) => {
  return fetchData<{ data: InstagramMedia[] }>({
    method: 'GET',
    uri: '/store/instagram/media',
    query: {
      results,
    },
  });
};
